import React from 'react';
type SolutionCardProps = {
  title: string;
  text: string;
  note?: string;
  image: string;
  alt: string;
  hidden?: boolean;
};
export function SolutionCard({
  title,
  text,
  note,
  image,
  alt,
  hidden = false
}: SolutionCardProps) {
  return <article aria-hidden={hidden || undefined} className="group flex w-[280px] shrink-0 flex-col overflow-hidden rounded-[4px] bg-cream shadow-[0_1px_0_rgba(22,58,62,0.08)] sm:w-[320px]" data-id="element-195" data-mp="370ib6hrzxvbj">
      <div className="aspect-[4/3] overflow-hidden bg-sand" data-id="element-196" data-mp="2falxtudohjdl">
        <img src={image} alt={hidden ? '' : alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-300 ease-out group-hover:scale-[1.04]" data-id="element-197" data-mp="2j9mhff3zcq1n" />
      </div>
      <div className="flex flex-1 flex-col p-6" data-id="element-198" data-mp="2t9ve0u1vwdhk">
        <h3 className="font-serif text-xl font-bold leading-snug text-ink" data-id="element-199" data-mp="3jrqqxvo3fqb">{title}</h3>
        <p className="mt-2 text-[15px] leading-relaxed text-body" data-id="element-200" data-mp="8i31datsdu9l">{text}</p>
        {note && <p className="mt-auto pt-4 text-xs font-bold uppercase tracking-[0.12em] text-gold" data-id="element-201" data-mp="8k62apwh97t3">{note}</p>}
      </div>
    </article>;
}